import { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { adapter } from "@/services/db";
import { DocumentPanel } from "./DocumentPanel";

// Lists docs of another collection linked to this one (e.g. lead_distributions where request_id == id).
export function RelatedDocs({ label, path, filters, describe }) {
  const [docs, setDocs] = useState([]);
  const [open, setOpen] = useState(null);
  const key = JSON.stringify(filters);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => adapter.subscribeWhere(path, filters, setDocs), [path, key]);
  return (
    <div className="mt-4" data-testid={`related-${path}`}>
      <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-2">{label} · {path} ({docs.length})</p>
      {docs.length === 0 && <p className="text-xs text-muted-foreground">None.</p>}
      <div className="space-y-1.5">
        {docs.map((d) => (
          <div key={d.id} className="rounded-md border border-border">
            <button onClick={() => setOpen(open === d.id ? null : d.id)} className="w-full flex items-center justify-between px-2.5 py-2 text-left hover:bg-accent/40" data-testid={`related-toggle-${d.id}`}>
              <span className="text-xs min-w-0 truncate"><span className="font-mono text-primary">{d.id}</span>{describe ? <span className="text-muted-foreground"> · {describe(d)}</span> : null}</span>
              <Icons.ChevronDown className={`h-3.5 w-3.5 shrink-0 text-muted-foreground transition-transform ${open === d.id ? "rotate-180" : ""}`} />
            </button>
            {open === d.id && <div className="px-2.5 pb-2.5"><DocumentPanel path={path} id={d.id} /></div>}
          </div>
        ))}
      </div>
    </div>
  );
}
